import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type {
  AtualizarStatusUsuario,
  AtualizarUsuario,
  CriarUsuario,
} from "@base/contracts";
import { useAuth } from "../../../shared/auth/auth.contexto";
import { useUsuariosGateway } from "./usuarios.contexto";

const chaveLista = ["usuarios", "lista"] as const;
const chavePapeis = ["usuarios", "papeis"] as const;

export function useTemGerirUsuarios(): boolean {
  const { sessao } = useAuth();
  return sessao?.escopos.includes("usuarios:escrever") ?? false;
}

export function usePodeVerUsuarios(): boolean {
  const { sessao } = useAuth();
  return sessao?.escopos.includes("usuarios:ler") ?? false;
}

export function useListarUsuarios(consulta?: {
  readonly q?: string;
  readonly status?: "ativo" | "inativo" | "todos";
}) {
  const gateway = useUsuariosGateway();
  return useQuery({
    queryKey: [...chaveLista, consulta?.q ?? "", consulta?.status ?? "ativo"],
    queryFn: () => gateway.listar(consulta),
  });
}

export function useListarPapeis(habilitado = true) {
  const gateway = useUsuariosGateway();
  return useQuery({
    queryKey: chavePapeis,
    queryFn: () => gateway.listarPapeis(),
    enabled: habilitado,
  });
}

export function useCriarUsuario() {
  const gateway = useUsuariosGateway();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (corpo: CriarUsuario) => gateway.criar(corpo),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: chaveLista });
    },
  });
}

export function useAtualizarUsuario() {
  const gateway = useUsuariosGateway();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (entrada: { id: string; corpo: AtualizarUsuario }) =>
      gateway.atualizar(entrada.id, entrada.corpo),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: chaveLista });
    },
  });
}

export function useAtualizarStatusUsuario() {
  const gateway = useUsuariosGateway();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (entrada: { id: string; corpo: AtualizarStatusUsuario }) =>
      gateway.atualizarStatus(entrada.id, entrada.corpo),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: chaveLista });
    },
  });
}
